import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter, withComponentInputBinding, withRouterConfig } from "@angular/router";
import { provideNzI18n, en_US } from "ng-zorro-antd/i18n";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzNotificationModule } from "ng-zorro-antd/notification";
import { FormsModule } from "@angular/forms";
import { AuthModule } from "@auth0/auth0-angular";
import { environment } from "@environments/environment";
import { routes } from "./app.routes";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { providePostHogErrorHandler, providePostHogPageviewTracking } from "@handshake/core-fe";
import {
  CalendarOutline,
  CheckCircleOutline,
  CheckOutline,
  ClockCircleOutline,
  CloseOutline,
  CloudUploadOutline,
  CreditCardOutline,
  DeleteOutline,
  DollarCircleOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  ExclamationCircleOutline,
  FileOutline,
  FileTextOutline,
  LoadingOutline,
  LockOutline,
  PaperClipOutline,
  PlusCircleOutline,
  SafetyCertificateOutline,
  SwapOutline,
  UploadOutline,
} from "@ant-design/icons-angular/icons";

const icons = [
  CalendarOutline,
  CheckCircleOutline,
  CheckOutline,
  ClockCircleOutline,
  CloseOutline,
  CloudUploadOutline,
  CreditCardOutline,
  DeleteOutline,
  DollarCircleOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  ExclamationCircleOutline,
  FileOutline,
  FileTextOutline,
  LoadingOutline,
  LockOutline,
  PaperClipOutline,
  PlusCircleOutline,
  SafetyCertificateOutline,
  SwapOutline,
  UploadOutline,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: "always" })),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule, NzNotificationModule, NzModalModule),
    provideAnimationsAsync(),
    importProvidersFrom(
      AuthModule.forRoot({
        domain: environment.auth0.domain,
        clientId: environment.auth0.clientId,
        authorizationParams: {
          redirect_uri: window.location.origin + "/callback",
          audience: environment.auth0.audience,
          scope: "openid profile email offline_access",
        },
        httpInterceptor: {
          allowedList: [
            {
              uri: `${environment.apiUrl}/*`,
              tokenOptions: {
                authorizationParams: {
                  audience: environment.auth0.audience,
                  scope: "openid profile email offline_access",
                },
              },
            },
          ],
        },
        useRefreshTokens: true,
        cacheLocation: "localstorage",
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(NzIconModule.forRoot(icons)),
    providePostHogErrorHandler(),
    providePostHogPageviewTracking(),
  ],
};
